import { LANGUAGES } from 'helpers/constants';
import sanitizeHtml from 'utills/sanitizeHtml';

/**
 * Returns sanitized localized text based on the current language setting.
 *
 * @param {string} language - Active language ('english', 'spanish', 'bilingual').
 * @param {string} primary - Primary (English) text.
 * @param {string} translated - Translated (Spanish) text.
 * @param {string} [separator=' '] - Separator used between translated and primary in bilingual mode.
 * @returns {string} Sanitized localized text string.
 */
export const getLocalizedText = (language, primary, translated, separator = ' ') => {
  let text;
  if (language === LANGUAGES.BILINGUAL && translated) text = `${translated}${separator}${primary}`;
  else if (language === LANGUAGES.SPANISH) text = translated || primary;
  else text = primary;
  return sanitizeHtml(text);
};
